import { TicketStatusColors, TicketGroupStatusColors } from '~/typings/enums/Ticket/TicketStatus';

export const COMPLETE_GROUP_STATUS_ID = 3;

export enum TicketPrioritiesNames {
  HIGH = 'Alta',
  MEDIUM = 'Média',
  LOW = 'Baixa',
  WAITING_DEFINITION = 'Aguardando definição',
}

const StatusColors = {
  1: 'neutral',
  2: 'alert',
  3: 'positive',
  21: 'negative',
};

export const getTicketStatusColor = (statusList, statusId) => {
  const status = statusList.find((status) => status.id === statusId);
  const statusColor = TicketStatusColors[status?.id];
  const groupStatusColors = TicketGroupStatusColors[status?.groupStatusId];
  return statusColor || groupStatusColors || null;
};

export const isTicketStatusComplete = (statusList, statusId) => {
  const status = statusList.find((status) => status.id === statusId);
  return status?.groupStatusId === COMPLETE_GROUP_STATUS_ID;
};

const EDITABLE_STATUS_NAMES = ['aguardando tratativa', 'em tratativa', 'reaberto', 'pendente cliente'];

export const isTicketEditable = (statusList, statusId) => {
  const status = statusList?.find((s) => s.id === statusId);
  const name = status?.name?.trim().toLowerCase();
  return EDITABLE_STATUS_NAMES.includes(name);
};

export const getJourneyId = (journeyLabel, journeys) =>
  journeys?.find((journey) => journey.name === journeyLabel)?.id
    ? [journeys?.find((journey) => journey.name === journeyLabel).id]
    : [];

export const resolveSelectedJourney = (currentJourney, initialJourney, filteredJourneys) => {
  if (initialJourney) return initialJourney;
  return filteredJourneys?.some((journey) => journey.id === currentJourney) ? currentJourney : null;
};

export const resolveProductName = (rawProduct, products = []) => {
  if (!rawProduct) return rawProduct;
  const matched = products?.find((product) => product?.name === rawProduct || product?.description === rawProduct);
  return matched?.name || rawProduct;
};

export const checkDateDifferenceInDays = (date) =>
  (new Date().getTime() - new Date(date).getTime()) / (1000 * 60 * 60 * 24);

export const FGTSInitialJourneyStep = (
  person,
  filteredJourneys,
  qiTechOpportunity,
  selectedContracts,
  operationStepId,
) => {
  if (person?.isOpportunity) {
    return getJourneyId('Simulação', filteredJourneys);
  }

  if (qiTechOpportunity === 'OK') {
    return getJourneyId('Integração', filteredJourneys);
  }

  if (qiTechOpportunity === 7) {
    return getJourneyId('Integração', filteredJourneys);
  }

  if (!selectedContracts.length) return [];

  return [operationStepId];
};

export const INSSInitialJourneyStep = (person, filteredJourneys, selectedContracts, operationStepId) => {
  if (person?.isOpportunity) {
    return getJourneyId('Simulação', filteredJourneys);
  }

  if (checkDateDifferenceInDays(person.portabilityUpdateDate) > 90) {
    return getJourneyId('Integração', filteredJourneys);
  }

  if (!selectedContracts.length) return [];

  return [operationStepId];
};

export const filteredStatus = (status: any[], stepLabel: string) =>
  (status ?? [])
    .filter((s) => Array.isArray(s?.steps) && s.steps.includes(stepLabel))
    .map((s) => ({
      ...s,
      label: s.name,
      value: s.id,
    }));

export const normalizeStatusGroup = (statusGroup) =>
  statusGroup?.map((status) => ({
    label: status.name,
    value: status.id,
    color: StatusColors[status.id],
  }));

export const normalizeData = (options) =>
  options?.map((option) => ({
    label: option.name,
    value: option.id,
  })) || [];

export const normalizeProducts = (products) =>
  products?.map((product) => ({
    label: product.description,
    value: product.name,
  }));

export const normalizedInitialData = (array, value) =>
  array?.find((option) => option.id === value) ? normalizeData([array.find((option) => option.id === value)])[0] : null;

export const normalizedInitialStatusData = (array, value) =>
  array?.find((option) => option.id === value)
    ? normalizeStatusGroup([array.find((option) => option.id === value)])[0]
    : null;

export const normalizedInitialResolvingArea = (array, id, path = []) =>
  array.reduce((result, item) => {
    if (result) return result;

    if (item.id === id) {
      return [...path, item.id];
    }

    if (item.children && item.children.length > 0) {
      const childResult = normalizedInitialResolvingArea(item.children, id, [...path, item.id]);
      if (childResult) return childResult;
    }

    return null;
  }, null);
